import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/CookieConsent.module.css';
import { getConsent, setConsent, hasDecided } from '../lib/cookieConsent';

const CookieConsent = () => {
    // Calculado en el inicializador (no en un useEffect posterior) para que
    // el banner aparezca en el primer render, no uno despues -- esta app no
    // hace SSR/hydration de verdad (index.js usa createRoot().render(), no
    // hydrateRoot()), asi que leer localStorage aqui es seguro y ahorra un
    // ciclo de render entero antes de que el usuario vea el banner.
    const [visible, setVisible] = useState(() => !hasDecided());
    const [showDetails, setShowDetails] = useState(false);
    const [analytics, setAnalytics] = useState(() => Boolean(getConsent()?.analytics));
    const [marketing, setMarketing] = useState(() => Boolean(getConsent()?.marketing));

    if (!visible) {
        return null;
    }

    const acceptAll = () => {
        setConsent({ analytics: true, marketing: true });
        setVisible(false);
    };

    const rejectNonEssential = () => {
        setConsent({ analytics: false, marketing: false });
        setVisible(false);
    };

    const saveCustom = () => {
        setConsent({ analytics, marketing });
        setVisible(false);
    };

    return (
        <div className={styles.banner} role="dialog" aria-label="Configuracion de cookies" aria-live="polite">
            <div className={styles.content}>
                <p>
                    Usamos almacenamiento necesario para que la web funcione (como guardar tus alertas de precio).
                    Con tu permiso, tambien nos gustaria medir visitas para mejorar Esganga. Puedes cambiar esto
                    cuando quieras en la{' '}
                    <Link to="/politica-cookies">Politica de cookies</Link>.
                </p>

                {showDetails && (
                    <div className={styles.details}>
                        <label className={styles.toggleRow}>
                            <span>Necesarias (siempre activas)</span>
                            <input type="checkbox" checked disabled />
                        </label>
                        <label className={styles.toggleRow}>
                            <span>Analitica (medicion propia y Google Analytics)</span>
                            <input
                                type="checkbox"
                                checked={analytics}
                                onChange={(event) => setAnalytics(event.target.checked)}
                            />
                        </label>
                        <label className={styles.toggleRow}>
                            <span>Marketing (entender que ofertas interesan mas)</span>
                            <input
                                type="checkbox"
                                checked={marketing}
                                onChange={(event) => setMarketing(event.target.checked)}
                            />
                        </label>
                    </div>
                )}

                <div className={styles.actions}>
                    {!showDetails && (
                        <button type="button" className={styles.linkButton} onClick={() => setShowDetails(true)}>
                            Personalizar
                        </button>
                    )}
                    {showDetails && (
                        <button type="button" className={styles.secondaryButton} onClick={saveCustom}>
                            Guardar seleccion
                        </button>
                    )}
                    <button type="button" className={styles.secondaryButton} onClick={rejectNonEssential}>
                        Rechazar
                    </button>
                    <button type="button" className={styles.primaryButton} onClick={acceptAll}>
                        Aceptar todas
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
